export enum MethodOfPaymentProcess {
    CHOOSE_METHOD = "CHOOSE_METHOD",
    ADD_CREDIT_CARD = "ADD_CREDIT_CARD",
    ADD_CURRENT_ACCOUNT = "ADD_CURRENT_ACCOUNT",
    DOWNLOAD_SEPA = "DOWNLOAD_SEPA"
}
